function finite(value, fallback=0) {
  const n=Number(value);
  return Number.isFinite(n)?n:fallback;
}

export function ramHeightFrom(value={}, meta=null) {
  if(value?.trackType==='ram') return finite(value?.componentMeta?.ramHeight, finite(value?.nativeSpecs?.h,0));
  if(meta) return finite(meta?.ramHeight, finite(value?.h,0));
  return finite(value?.ramHeight, finite(value?.h,0));
}

export function coolerRamClearance(meta={}) {
  const open=!!meta?.ramClearanceOpen;
  const value=finite(meta?.ramClearance,0);
  const known=!!meta?.ramClearanceKnown || open || value>0;
  return {open,value,known};
}

export function evaluateRamCoolerCompatibility(ramHeight, coolerMeta={}) {
  const h=finite(ramHeight,0);
  const clearance=coolerRamClearance(coolerMeta);
  if(!h || !clearance.known) {
    return {
      allowed:true,
      compatible:true,
      known:!!clearance.known && h>0,
      reason:'ram_clearance_unknown',
      advisory:!clearance.known?'CPU cooler RAM clearance is unknown':null,
      ramHeight:h,
      clearance:clearance.value,
      clearanceKnown:clearance.known,
      clearanceOpen:clearance.open
    };
  }
  if(clearance.open) return {allowed:true,compatible:true,known:true,reason:'ram_clearance_open',ramHeight:h,clearance:0,clearanceKnown:true,clearanceOpen:true};
  if(clearance.value>0 && h>clearance.value+0.01) {
    return {
      allowed:false,
      compatible:false,
      known:true,
      reason:`RAM height ${Math.round(h*10)/10} mm exceeds cooler clearance ${Math.round(clearance.value*10)/10} mm`,
      code:'ram_cooler_clearance_fail',
      ramHeight:h,
      clearance:clearance.value,
      clearanceKnown:true,
      clearanceOpen:false
    };
  }
  return {allowed:true,compatible:true,known:true,reason:'ram_within_cooler_clearance',ramHeight:h,clearance:clearance.value,clearanceKnown:true,clearanceOpen:false};
}

export function ramCoolerPairCompatibility(a,b) {
  const ram=a?.trackType==='ram'?a:(b?.trackType==='ram'?b:null);
  const cooler=a?.trackType==='aircooler'?a:(b?.trackType==='aircooler'?b:null);
  if(!ram||!cooler)return null;
  return evaluateRamCoolerCompatibility(ramHeightFrom(ram),cooler?.componentMeta||{});
}
